import { __assign, __extends } from "tslib";
import React from "react";
var SVG = /** @class */ (function (_super) {
    __extends(SVG, _super);
    function SVG() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    SVG.prototype.render = function () {
        return React.createElement("svg", __assign({ xmlns: "http://www.w3.org/2000/svg", width: "22", height: "15", viewBox: "0 0 22 15" }, this.props),
            React.createElement("path", { d: "M4 6V3H3v3H0v1h3v3h1V7h3V6H4zm10.952 8h3.032l1.015-1H14zm.479 1h2.137c-.047-.223-.047-.39 0-.5.048-.11.191-.277.43-.5h-2.997c.235.214.379.38.43.5.052.12.052.286 0 .5zm5.402-5.887V6.182c0-2.233-1.184-4.102-3.25-4.597v-.494C17.583.487 17.1 0 16.5 0s-1.083.487-1.083 1.09v.495c-2.073.495-3.25 2.357-3.25 4.597v2.93L11.2 10.4A1 1 0 0 0 12 12h8.998a1 1 0 0 0 .8-1.6l-.966-1.287z", fillRule: "evenodd" }));
    };
    return SVG;
}(React.Component));
export default SVG;
